export const PART_CATEGORIES = [
  'Tyres',
  'Wheels and Rims',
  'Belts',
  'Chains',
  'Blades',
  'Filters',
  'Spark Plugs',
  'Carburettors and Carb Parts',
  'Batteries',
  'Electrical Components',
  'Gaskets and Seals',
  'Fuel System Parts',
  'Ignition Parts',
  'Recoil and Starting Parts',
  'Fasteners',
  'Bearings and Bushings',
  'Springs and Cables',
  'Hydraulic Parts',
  'Engine Components',
  'Drive and Transmission Parts',
];

export const PART_CATEGORY_GROUPS = [
  { label: 'Tyres & Wheels',  categories: ['Tyres', 'Wheels and Rims'] },
  { label: 'Engine',          categories: ['Engine Components', 'Gaskets and Seals', 'Recoil and Starting Parts'] },
  { label: 'Fuel & Induction',categories: ['Carburettors and Carb Parts', 'Fuel System Parts'] },
  { label: 'Ignition',        categories: ['Spark Plugs', 'Ignition Parts', 'Electrical Components', 'Batteries'] },
  { label: 'Drive Train',     categories: ['Belts', 'Chains', 'Bearings and Bushings', 'Drive and Transmission Parts', 'Springs and Cables'] },
  { label: 'Cutting',         categories: ['Blades'] },
  { label: 'Filters',         categories: ['Filters'] },
  { label: 'Fasteners',       categories: ['Fasteners'] },
  { label: 'Hydraulics',      categories: ['Hydraulic Parts'] },
];

export const PART_CATEGORY_ICON = {
  'Tyres':                       '🛞',
  'Wheels and Rims':             '🔵',
  'Belts':                       '➰',
  'Chains':                      '⛓️',
  'Blades':                      '🔪',
  'Filters':                     '🔲',
  'Spark Plugs':                 '⚡',
  'Carburettors and Carb Parts': '🔧',
  'Batteries':                   '🔋',
  'Electrical Components':       '🔌',
  'Gaskets and Seals':           '💿',
  'Fuel System Parts':           '⛽',
  'Ignition Parts':              '🔥',
  'Recoil and Starting Parts':   '🌀',
  'Fasteners':                   '🔩',
  'Bearings and Bushings':       '⚙️',
  'Springs and Cables':          '〰️',
  'Hydraulic Parts':             '💧',
  'Engine Components':           '🪛',
  'Drive and Transmission Parts':'⚙️',
};

export const PART_CATEGORY_COLOR = {
  'Tyres':                       '#6a6a6a',
  'Wheels and Rims':             '#4a90a4',
  'Belts':                       '#8B4513',
  'Chains':                      '#555555',
  'Blades':                      '#c94040',
  'Filters':                     '#4a90a4',
  'Spark Plugs':                 '#f5c842',
  'Carburettors and Carb Parts': '#e8870a',
  'Batteries':                   '#50a050',
  'Electrical Components':       '#6a5acd',
  'Gaskets and Seals':           '#b0b0b0',
  'Fuel System Parts':           '#d05000',
  'Ignition Parts':              '#cc4400',
  'Recoil and Starting Parts':   '#20a0a0',
  'Fasteners':                   '#808080',
  'Bearings and Bushings':       '#3a7bd5',
  'Springs and Cables':          '#7a9a7a',
  'Hydraulic Parts':             '#2060a0',
  'Engine Components':           '#a04020',
  'Drive and Transmission Parts':'#505080',
};

export const PART_CATEGORY_SPECS = {
  'Tyres': [
    { key: 'width',        label: 'Width (mm)',       type: 'number', placeholder: 'e.g. 205' },
    { key: 'aspect_ratio', label: 'Aspect Ratio',     type: 'number', placeholder: 'e.g. 55' },
    { key: 'construction', label: 'Construction',     type: 'select', options: ['R', 'D', 'B'] },
    { key: 'rim_diameter', label: 'Rim Diameter (in)',type: 'number', placeholder: 'e.g. 16' },
    { key: 'display_size', label: 'Display Size',     type: 'text',   placeholder: 'e.g. 205/55R16' },
    { key: 'load_rating',  label: 'Load Rating',      type: 'text',   placeholder: 'e.g. 91' },
    { key: 'speed_rating', label: 'Speed Rating',     type: 'select', options: ['L','M','N','P','Q','R','S','T','U','H','V','W','Y','Z','ZR'] },
    { key: 'season',       label: 'Season',           type: 'select', options: ['Summer','Winter','All Season','All Terrain','Mud'] },
    { key: 'run_flat',     label: 'Run Flat',         type: 'select', options: ['Yes','No'] },
    { key: 'ply_rating',   label: 'Ply Rating',       type: 'number', placeholder: 'e.g. 4' },
    { key: 'dot_code',     label: 'DOT Code',         type: 'text',   placeholder: 'e.g. DOT XXXX XXXX 2024' },
    { key: 'fits',         label: 'Compatible Vehicles', type: 'text', placeholder: 'e.g. Ford Ranger 2015+' },
  ],
  'Wheels and Rims': [
    { key: 'material',     label: 'Material',         type: 'select', options: ['Steel','Alloy','Forged Alloy','Carbon Fibre'] },
    { key: 'rim_diameter', label: 'Rim Diameter (in)',type: 'number', placeholder: 'e.g. 17' },
    { key: 'rim_width',    label: 'Rim Width (in)',   type: 'number', placeholder: 'e.g. 8' },
    { key: 'offset',       label: 'Offset (ET)',      type: 'text',   placeholder: 'e.g. ET35' },
    { key: 'pcd',          label: 'PCD',              type: 'text',   placeholder: 'e.g. 5x114.3' },
    { key: 'centre_bore',  label: 'Centre Bore (mm)', type: 'number', placeholder: 'e.g. 67.1' },
    { key: 'finish',       label: 'Finish / Colour',  type: 'text',   placeholder: 'e.g. Gloss Black' },
    { key: 'fits',         label: 'Compatible Vehicles', type: 'text', placeholder: 'e.g. Toyota Hilux' },
  ],
  'Belts': [
    { key: 'type',    label: 'Belt Type', type: 'select', options: ['V-Belt','Flat Belt','Timing Belt','Poly-V','Cogged','Kevlar','Drive Belt'] },
    { key: 'width',   label: 'Width (mm)',  type: 'number', placeholder: 'e.g. 13' },
    { key: 'length',  label: 'Length (mm)', type: 'number', placeholder: 'e.g. 1000' },
    { key: 'profile', label: 'Profile / Section', type: 'select', options: ['A','B','C','Z','3L','4L','5L','SPZ','SPA','SPB','SPC','Other'] },
    { key: 'fits',    label: 'Compatible Machines', type: 'text', placeholder: 'e.g. Honda HRU216' },
  ],
  'Chains': [
    { key: 'type',        label: 'Chain Type',    type: 'select', options: ['Chainsaw Chain','Drive Chain','Roller Chain','Timing Chain','O-Ring Chain'] },
    { key: 'pitch',       label: 'Pitch',         type: 'text',   placeholder: 'e.g. .325"' },
    { key: 'gauge',       label: 'Gauge',         type: 'text',   placeholder: 'e.g. .050"' },
    { key: 'drive_links', label: 'Drive Links',   type: 'number', placeholder: 'e.g. 72' },
    { key: 'bar_length',  label: 'Bar Length (in)',type: 'number', placeholder: 'e.g. 18' },
    { key: 'fits',        label: 'Compatible Machines', type: 'text', placeholder: 'e.g. Stihl MS261' },
  ],
  'Blades': [
    { key: 'type',        label: 'Blade Type',         type: 'select', options: ['Mower Blade','Hedge Trimmer Blade','Brush Cutter Blade','Chipper Blade','Saw Blade'] },
    { key: 'length',      label: 'Length (mm)',         type: 'number', placeholder: 'e.g. 480' },
    { key: 'thickness',   label: 'Thickness (mm)',      type: 'number', placeholder: 'e.g. 4' },
    { key: 'width',       label: 'Width (mm)',          type: 'number', placeholder: 'e.g. 50' },
    { key: 'centre_hole', label: 'Centre Hole',         type: 'text',   placeholder: 'e.g. 20mm round' },
    { key: 'lift',        label: 'Lift Type',           type: 'select', options: ['Low Lift','Medium Lift','High Lift','Mulching','Gator','Flat'] },
    { key: 'fits',        label: 'Compatible Machines', type: 'text',   placeholder: 'e.g. Husqvarna Rider 155' },
  ],
  'Filters': [
    { key: 'type',     label: 'Filter Type',    type: 'select', options: ['Air Filter','Oil Filter','Fuel Filter','Hydraulic Filter','Inline Filter','Pre-Filter','Cabin Filter'] },
    { key: 'shape',    label: 'Shape',          type: 'select', options: ['Panel','Cylindrical','Conical','Flat','Oval'] },
    { key: 'od',       label: 'Outer Dia. (mm)',type: 'number', placeholder: 'e.g. 76' },
    { key: 'id_inner', label: 'Inner Dia. (mm)',type: 'number', placeholder: 'e.g. 62' },
    { key: 'height',   label: 'Height (mm)',    type: 'number', placeholder: 'e.g. 90' },
    { key: 'thread',   label: 'Thread (spin-on)',type: 'text',  placeholder: 'e.g. M20x1.5' },
    { key: 'micron',   label: 'Micron Rating',  type: 'number', placeholder: 'e.g. 10' },
    { key: 'fits',     label: 'Compatible Machines', type: 'text', placeholder: 'e.g. Honda GX390' },
  ],
  'Spark Plugs': [
    { key: 'thread_dia',   label: 'Thread Diameter', type: 'text',   placeholder: 'e.g. 14mm' },
    { key: 'thread_pitch', label: 'Thread Pitch',    type: 'text',   placeholder: 'e.g. 1.25' },
    { key: 'reach',        label: 'Reach',           type: 'text',   placeholder: 'e.g. 19mm' },
    { key: 'hex_size',     label: 'Hex Size',        type: 'text',   placeholder: 'e.g. 16mm' },
    { key: 'gap',          label: 'Gap',             type: 'text',   placeholder: 'e.g. 0.7mm' },
    { key: 'heat_range',   label: 'Heat Range',      type: 'text',   placeholder: 'e.g. 6' },
    { key: 'electrode',    label: 'Electrode Type',  type: 'select', options: ['Standard','Iridium','Platinum','Double Platinum','Iridium IX'] },
    { key: 'resistor',     label: 'Resistor',        type: 'select', options: ['Yes','No'] },
    { key: 'fits',         label: 'Compatible Machines', type: 'text', placeholder: 'e.g. Husqvarna 135' },
  ],
  'Carburettors and Carb Parts': [
    { key: 'type',         label: 'Part Type',       type: 'select', options: ['Complete Carburettor','Rebuild Kit','Diaphragm','Gasket Set','Needle','Jet','Float','Primer Bulb'] },
    { key: 'brand_model',  label: 'Carb Brand',      type: 'select', options: ['Walbro','Zama','Tillotson','Nikki','Ruixing','Keihin','Mikuni','Dellorto','Other'] },
    { key: 'throat_dia',   label: 'Throat Dia. (mm)',type: 'number', placeholder: 'e.g. 16' },
    { key: 'bolt_spacing', label: 'Bolt Centres (mm)',type:'number', placeholder: 'e.g. 25' },
    { key: 'fits',         label: 'Compatible Machines / Carb Models', type: 'text', placeholder: 'e.g. Stihl 023, Walbro WA-1' },
  ],
  'Batteries': [
    { key: 'type',         label: 'Battery Type',    type: 'select', options: ['Lead Acid','AGM','Gel','Lithium','LiFePO4','NiMH','NiCd'] },
    { key: 'voltage',      label: 'Voltage (V)',      type: 'number', placeholder: 'e.g. 12' },
    { key: 'ah',           label: 'Capacity (Ah)',    type: 'number', placeholder: 'e.g. 35' },
    { key: 'cca',          label: 'CCA Rating',       type: 'number', placeholder: 'e.g. 330' },
    { key: 'terminal',     label: 'Terminal Type',    type: 'select', options: ['Top Terminal','Side Terminal','Other'] },
    { key: 'terminal_pos', label: 'Positive Terminal',type: 'select', options: ['Left Positive','Right Positive'] },
    { key: 'group_size',   label: 'Group / BCI Size', type: 'text',   placeholder: 'e.g. 35, DIN66, N70' },
    { key: 'dims',         label: 'Dimensions (mm)',  type: 'text',   placeholder: 'L x W x H' },
  ],
  'Electrical Components': [
    { key: 'type',     label: 'Component Type', type: 'select', options: ['Alternator','Starter Motor','Regulator/Rectifier','Ignition Coil','CDI Unit','Relay','Switch','Solenoid','Fuse','Sensor','Wiring Harness'] },
    { key: 'voltage',  label: 'Voltage',        type: 'text',   placeholder: 'e.g. 12V' },
    { key: 'amperage', label: 'Amperage',       type: 'text',   placeholder: 'e.g. 30A' },
    { key: 'fits',     label: 'Compatible Machines / Vehicles', type: 'text', placeholder: 'e.g. Yamaha YFZ450' },
  ],
  'Gaskets and Seals': [
    { key: 'type',     label: 'Gasket / Seal Type', type: 'select', options: ['Head Gasket','Base Gasket','Carb Gasket','Oil Seal','Crankshaft Seal','O-Ring','Gasket Set','Valve Stem Seal','Water Pump Seal'] },
    { key: 'material', label: 'Material',            type: 'select', options: ['Paper','Copper','Composite','Rubber','Silicone','Graphite','MLS Steel'] },
    { key: 'dims',     label: 'Dimensions (mm)',     type: 'text',   placeholder: 'OD x ID x H' },
    { key: 'fits',     label: 'Compatible Machines', type: 'text',   placeholder: 'e.g. Honda GX200' },
  ],
  'Fuel System Parts': [
    { key: 'type',     label: 'Part Type',       type: 'select', options: ['Fuel Tank','Fuel Cap','Fuel Line','Fuel Filter','Primer Bulb','Petcock','Fuel Pump','Pulse Line','Grommet'] },
    { key: 'diameter', label: 'Hose Inner Dia.', type: 'text',   placeholder: 'e.g. 5mm' },
    { key: 'length',   label: 'Length (mm)',      type: 'number', placeholder: 'e.g. 300' },
    { key: 'material', label: 'Material',         type: 'select', options: ['Rubber','Braided Rubber','Ethanol Resistant','Plastic','Aluminium'] },
    { key: 'fits',     label: 'Compatible Machines', type: 'text', placeholder: 'e.g. Stihl FS90' },
  ],
  'Ignition Parts': [
    { key: 'type',    label: 'Part Type', type: 'select', options: ['Ignition Coil','Points','Condenser','Flywheel','Kill Switch','Ignition Module','CDI Unit','Magneto'] },
    { key: 'air_gap', label: 'Air Gap',   type: 'text',   placeholder: 'e.g. 0.30mm' },
    { key: 'fits',    label: 'Compatible Machines', type: 'text', placeholder: 'e.g. Briggs & Stratton 450E' },
  ],
  'Recoil and Starting Parts': [
    { key: 'type',        label: 'Part Type',        type: 'select', options: ['Recoil Assembly','Pull Cord','Recoil Spring','Starter Handle','Pawl','Ratchet','Pulley'] },
    { key: 'cord_dia',    label: 'Cord Diameter (mm)',type: 'text',  placeholder: 'e.g. 3.5' },
    { key: 'cord_length', label: 'Cord Length (mm)', type: 'number', placeholder: 'e.g. 1200' },
    { key: 'fits',        label: 'Compatible Machines', type: 'text', placeholder: 'e.g. Honda GX35' },
  ],
  'Fasteners': [
    { key: 'type',      label: 'Fastener Type',  type: 'select', options: ['Bolt','Nut','Washer','Stud','Screw','Rivet','Clip','Pin','Circlip','Split Pin'] },
    { key: 'standard',  label: 'Thread Standard',type: 'select', options: ['Metric','Imperial','UNC','UNF','BSW','BSF'] },
    { key: 'diameter',  label: 'Diameter',        type: 'text',   placeholder: 'e.g. M10 or 3/8"' },
    { key: 'pitch',     label: 'Thread Pitch',    type: 'text',   placeholder: 'e.g. 1.25mm or 24 TPI' },
    { key: 'length',    label: 'Length (mm)',      type: 'number', placeholder: 'e.g. 40' },
    { key: 'head_type', label: 'Head Type',        type: 'select', options: ['Hex','Torx','Phillips','Slotted','Socket/Allen','Flange','Countersunk','Pan','Button'] },
    { key: 'grade',     label: 'Grade / Tensile',  type: 'text',   placeholder: 'e.g. 8.8, 10.9, Grade 5' },
    { key: 'finish',    label: 'Finish',           type: 'select', options: ['Zinc Plated','Stainless Steel','Black Oxide','Hot Dip Galv','Plain','Nickel'] },
  ],
  'Bearings and Bushings': [
    { key: 'type',       label: 'Bearing Type',    type: 'select', options: ['Ball Bearing','Needle Bearing','Thrust Bearing','Tapered Roller','Bushing/Sleeve','Plain Bearing'] },
    { key: 'bearing_no', label: 'Bearing Number',  type: 'text',   placeholder: 'e.g. 6202, 30205' },
    { key: 'id_inner',   label: 'Inner Dia. (mm)', type: 'number', placeholder: 'e.g. 15' },
    { key: 'od',         label: 'Outer Dia. (mm)', type: 'number', placeholder: 'e.g. 35' },
    { key: 'width',      label: 'Width (mm)',       type: 'number', placeholder: 'e.g. 11' },
    { key: 'seal',       label: 'Seal Type',        type: 'select', options: ['Open','Single Seal (Z)','Double Seal (ZZ)','Single Rubber (RS)','Double Rubber (2RS)'] },
    { key: 'fits',       label: 'Compatible Machines', type: 'text', placeholder: 'e.g. Honda HRU216 wheel' },
  ],
  'Springs and Cables': [
    { key: 'type',         label: 'Part Type',          type: 'select', options: ['Throttle Cable','Choke Cable','Brake Cable','Governor Spring','Return Spring','Torsion Spring','Compression Spring','Extension Spring'] },
    { key: 'length',       label: 'Length (mm)',         type: 'number', placeholder: 'e.g. 800' },
    { key: 'diameter',     label: 'Diameter / OD (mm)', type: 'text',   placeholder: 'e.g. 6' },
    { key: 'cable_outer',  label: 'Cable Outer Dia. (mm)', type: 'text', placeholder: 'e.g. 5' },
    { key: 'cable_inner',  label: 'Cable Inner Dia. (mm)', type: 'text', placeholder: 'e.g. 1.5' },
    { key: 'fits',         label: 'Compatible Machines', type: 'text',  placeholder: 'e.g. Husqvarna 135' },
  ],
  'Hydraulic Parts': [
    { key: 'type',     label: 'Part Type',          type: 'select', options: ['Hydraulic Hose','Fitting','Cylinder','Pump','Control Valve','Hydraulic Filter','Reservoir','Seal Kit'] },
    { key: 'hose_dia', label: 'Hose Inner Dia.',    type: 'text',   placeholder: 'e.g. 10mm' },
    { key: 'pressure', label: 'Pressure Rating',    type: 'text',   placeholder: 'e.g. 3000 PSI' },
    { key: 'fittings', label: 'End Fittings',       type: 'text',   placeholder: 'e.g. 1/4" BSP male' },
    { key: 'fits',     label: 'Compatible Machines',type: 'text',   placeholder: 'e.g. Kubota BX25' },
  ],
  'Engine Components': [
    { key: 'type',   label: 'Component Type',   type: 'select', options: ['Piston','Piston Ring Set','Connecting Rod','Crankshaft','Cylinder','Cylinder Head','Valve','Camshaft','Reed Valve','Gudgeon Pin','Big End Kit','Small End Kit'] },
    { key: 'bore',   label: 'Bore / Dia. (mm)', type: 'number', placeholder: 'e.g. 64' },
    { key: 'stroke', label: 'Stroke (mm)',       type: 'number', placeholder: 'e.g. 45' },
    { key: 'fits',   label: 'Compatible Engines', type: 'text', placeholder: 'e.g. Honda GX160, Robin EX17' },
  ],
  'Drive and Transmission Parts': [
    { key: 'type',     label: 'Part Type',   type: 'select', options: ['Clutch Drum','Clutch Shoe','Sprocket','Gear','Axle','Differential','Gearbox Component','Drive Shaft','Belt Pulley','Centrifugal Clutch'] },
    { key: 'teeth',    label: 'Teeth Count', type: 'number', placeholder: 'e.g. 7' },
    { key: 'diameter', label: 'Diameter (mm)', type: 'number', placeholder: 'e.g. 76' },
    { key: 'fits',     label: 'Compatible Machines', type: 'text', placeholder: 'e.g. Stihl MS461' },
  ],
};

const PCS_STANDARD = { default: 'pcs', options: ['pcs', 'set', 'pair'] };

export const PART_CATEGORY_UNITS = {
  'Tyres':                       PCS_STANDARD,
  'Wheels and Rims':             PCS_STANDARD,
  'Belts':                       PCS_STANDARD,
  'Chains':                      PCS_STANDARD,
  'Blades':                      PCS_STANDARD,
  'Filters':                     PCS_STANDARD,
  'Spark Plugs':                 { default: 'pcs', options: ['pcs', 'set', 'pair', 'box'] },
  'Carburettors and Carb Parts': PCS_STANDARD,
  'Batteries':                   PCS_STANDARD,
  'Electrical Components':       PCS_STANDARD,
  'Gaskets and Seals':           { default: 'pcs', options: ['pcs', 'set', 'kit'] },
  'Fuel System Parts':           { default: 'pcs', options: ['pcs', 'set', 'm', 'mm'] },
  'Ignition Parts':              PCS_STANDARD,
  'Recoil and Starting Parts':   { default: 'pcs', options: ['pcs', 'set', 'm'] },
  'Fasteners':                   { default: 'pcs', options: ['pcs', 'box', 'bag', 'pack', 'set'] },
  'Bearings and Bushings':       { default: 'pcs', options: ['pcs', 'set', 'pair'] },
  'Springs and Cables':          { default: 'pcs', options: ['pcs', 'set', 'm'] },
  'Hydraulic Parts':             { default: 'pcs', options: ['pcs', 'set', 'm'] },
  'Engine Components':           { default: 'pcs', options: ['pcs', 'set', 'kit'] },
  'Drive and Transmission Parts':PCS_STANDARD,
};
